import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Card,
  CardBody,
} from 'reactstrap';

import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import IntegrationInfo from './IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_Email_Integration,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import Example from '../Example';
import { injectIntl } from 'react-intl';
import Addons from './Addons';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import UnifiedInbox from './UnifiedInbox';
import TicketThread from './TicketThread';
import EmailForwarding from './EmailForwarding';
import EmailSignature from './EmailSignature';
import AutoReplies from './AutoReplies';
import AutonomousReplies from './AutonomousReplies';
import Topics from './Topics';
import topic from '../../../../../../data/topic';
import PreviewReply from './PreviewReply';
import DynamicFlow from './DynamicFlow';
function EmailIntegrationList({
  match,
  history,
  lang,
  propertyId,
  serviceProvider,
}) {
  const integrationId = match.params.id;
  let [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [unifiedInboxVisible, setUnifiedInboxVisible] = useState(false);
  const [ticketThreadVisible, setTicketThreadVisible] = useState(false);
  const [emailForwardingVisible, setEmailForwardingVisible] = useState(false);
  const [emailSignature, setEmailSignature] = useState(false);
  const [autoReplies, setAutoReplies] = useState(false);
  const [autonoumsReplies, setAutonoumsReplies] = useState(false);
  const [addons, setAddons] = useState(false);
  const [topics, setTopics] = useState(false);
  const [isDynamicFlow, setIsDynamicFlow] = useState(false);
  const [preview, setPreview] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState();
  const [propertyList, setPropertyList] = useState([]);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const showPreview = () => {
    setIsDynamicFlow(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setPreview(true);
  };

  const showTopics = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(true);
  };

  const bussiness = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(true);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
  };
  const unifiedInbox = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(true);
    setTicketThreadVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(false);
    setAddons(false);
    setTopics(false);
  };
  const ticketThread = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(true);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(false);
    setAddons(false);
    setTopics(false);
  };
  const setEmailForwarding = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(true);
    setAddons(false);
    setTopics(false);
  };
  const signature = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(true);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
  };
  const replyThread = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(false);
    setPreview(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(true);
    setAutoReplies(false);
    setAddons(false);
  };
  const autoReplyThread = () => {
    setIsDynamicFlow(false);
    setPropertyVisible(false);
    setPreview(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(true);
    setAddons(false);
    setTopics(false);
  };

  const handleAddons = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(false);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(true);
    setTopics(false);
  };

  const showDynamicFlow = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(true);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
  };

  useEffect(() => {
    LoadIntegrationData();
  }, [integrationId]);
  const LoadIntegrationData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_Email_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        }).then((json) => {
          setAllProperties(json.data);
          try {
            if (json.data.length > 0) {
              setPropertyDetails(
                json.data.filter((f) => res.data.properties.includes(f.id))[0]
              );
              setPropertyList(
                json.data.filter((f) => res.data.properties.includes(f.id))
              );
            }
          } catch {}
        });
      })
      .catch((err) => console.log('err', err));
  };
  const saveIntegration = (data) => {
    const { list, name, channelDetails } = data;
    if (channelDetails) {
      integration.channelDetails = channelDetails;
    }
    if (list) {
      integration.properties = list;
    }
    if (name) {
      integration.name = name;
    }
    AxiosAPI({
      method: 'put',
      url: `${API_Email_Integration}/${
        integration.id
      }?group_id=${getGroupID()}`,
      data: integration,
    })
      .catch((err) => console.error(err))
      .then(() => {
        NotificationManager.success(
          '',
          'integration updated.',
          3000,
          null,
          null,
          'success'
        );
        setTimeout(() => {
          LoadIntegrationData();
        }, 500);
      });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/channels');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${
                      propertyVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => bussiness()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select Businesses
                          </p>
                          <p className="mb-4 text-small">
                            Select the businesses whose emails are processed
                            through this integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      integration.channel === 'EmailAssistant' ? '' : 'd-none'
                    } ${unifiedInboxVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-inbox`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => unifiedInbox()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Unified Inbox
                          </p>
                          <p className="mb-4 text-small">
                            Enable the email channel in your Unified Inbox
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>

                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      integration.channel === 'EmailAssistant' ? '' : 'd-none'
                    } ${ticketThreadVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      {/* <FontAwesomeIcon icon={faTicketAlt} className="fa" /> */}
                      <div className={`glyph-icon iconsminds-mail-read`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => ticketThread()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Ticket Thread
                          </p>
                          <p className="mb-4 text-small">
                            View the ticket conversation thread in your Unified
                            Inbox
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      integration.channel === 'EmailAssistant' ? '' : 'd-none'
                    } ${emailForwardingVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-forward`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setEmailForwarding()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Email Forwarding
                          </p>
                          <p className="mb-4 text-small">
                            Enable Unified Inbox to receive, show, and reply to
                            forwarded emails
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      integration.channel === 'EmailAssistant' ? '' : 'd-none'
                    } ${emailSignature ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-love`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => signature()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Email Signatures
                          </p>
                          <p className="mb-4 text-small">
                            Customize the email signature for your business.
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      autonoumsReplies ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-reply`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => replyThread()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Autonomous Replies
                          </p>
                          <p className="mb-4 text-small">
                            Select the autonomy settings, the AI model, and the
                            prompt
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      isDynamicFlow ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-reply`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showDynamicFlow()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Dynamic Conversation Flow
                          </p>
                          <p className="mb-4 text-small">
                            Select the autonomy settings, the AI model, and the
                            prompt
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      integration.channel === 'EmailAssistant' ? '' : 'd-none'
                    } ${autoReplies ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-reply-all`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => autoReplyThread()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Auto-replies
                          </p>
                          <p className="mb-4 text-small">
                            Set up automatic replies to emails and set response
                            time expectations.
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      topics ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon simple-icon-menu`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showTopics()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Topic Detection
                          </p>
                          <p className="mb-4 text-small">
                            Detects the main topics in emails, helping you
                            categorize, respond, and analyze conversations
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${
                      addons ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-mail-with-cursors`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => handleAddons()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Microsoft Outlook Add-on
                          </p>
                          <p className="mb-4 text-small">
                            List email addresses that are allowed to connect
                            from Outlook
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={showPreview}
                    >
                      Test Email Responses
                    </Button>
                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}

              {isDynamicFlow && (
                <Fragment>
                  <DynamicFlow
                    lang={lang}
                    integration={integration}
                    propertyList={propertyList}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {unifiedInboxVisible && (
                <Fragment>
                  <UnifiedInbox
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {preview && (
                <Fragment>
                  <PreviewReply
                    lang={lang}
                    propertyId={
                      integration.properties.length > 0
                        ? integration.properties[0]
                        : propertyId
                    }
                    propertyDetails={propertyDetails}
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {ticketThreadVisible && (
                <Fragment>
                  <TicketThread
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {topics && (
                <Fragment>
                  <Topics
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {emailForwardingVisible && (
                <Fragment>
                  <EmailForwarding
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {emailSignature && (
                <Fragment>
                  <EmailSignature
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {addons && (
                <Fragment>
                  <Addons
                    integration={integration}
                    saveIntegration={saveIntegration}
                    allProperties={allProperties}
                    integrationId={integration.id}
                    propertyId={
                      integration.properties.length > 0
                        ? integration.properties[0]
                        : propertyId
                    }
                    serviceProvider={serviceProvider}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {autoReplies && (
                <Fragment>
                  <AutoReplies
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {autonoumsReplies && (
                <Fragment>
                  <AutonomousReplies
                    integrationProperties={integration.properties}
                    integration={integration}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, serviceProvider, locale } = settings;
  const lang = locale;
  return {
    propertyId,
    lang,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps, {})(EmailIntegrationList));
